import React, { useEffect, useState } from 'react'
import { api } from '../../../../core/api/ConnectionManager'
import styles from './styles.jcss'
import translate from '../../../../core/translate'
import { cn } from 'ethcss'
import {
    InstancesCatalogDaysAndClassesProps,
    InstancesCatalogSchoolClassItem,
} from './InstancesCatalogDaysAndClasses-types'

const days = [
    translate('monday'),
    translate('tuesday'),
    translate('wednesday'),
    translate('thursday'),
    translate('friday'),
    translate('saturday'),
]

export const InstancesCatalogDaysAndClasses = ({
    selectedClassNumber,
    selectedClassLetter,
    day,
    onDataChange,
}: InstancesCatalogDaysAndClassesProps) => {
    const [classList, setClassList] = useState<InstancesCatalogSchoolClassItem[]>([])

    useEffect(() => {
        api.send('getSchoolClasses', {}).then((res) => {
            const payload = res as { data: InstancesCatalogSchoolClassItem[] }
            setClassList(payload.data)
        })
    }, [])

    const getClassLetters = (classNumber: string) => {
        const findedClass = classList.find((classElement) => classElement.classNumber === classNumber)

        return findedClass ? findedClass.classLetters : []
    }

    return (
        <div>
            <div className={styles.days}>
                {days.map((dayLabel, index) => (
                    <div
                        key={dayLabel}
                        className={cn(styles.day, index + 1 === day ? styles.active : '')}
                        onClick={() => onDataChange('day', index + 1)}
                    >
                        {dayLabel}
                    </div>
                ))}
            </div>
            <div className={styles.classNumbers}>
                {classList.map((classroom) => (
                    <div
                        key={classroom.classNumber}
                        className={cn(
                            styles.classNumber,
                            classroom.classNumber === selectedClassNumber ? styles.active : ''
                        )}
                        onClick={() => {
                            onDataChange('selectedClassNumber', classroom.classNumber)
                        }}
                    >
                        {classroom.classNumber}
                    </div>
                ))}
            </div>
            <div className={styles.classLetters}>
                {getClassLetters(selectedClassNumber).map((letter) => (
                    <div
                        key={letter}
                        className={cn(styles.classLetter, letter === selectedClassLetter ? styles.active : '')}
                        onClick={() => {
                            onDataChange('selectedClassLetter', letter)
                        }}
                    >
                        {letter.toUpperCase()}
                    </div>
                ))}
            </div>
        </div>
    )
}
